export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const CONFIRM_EMAIL_START = 'CONFIRM__EMAIL_START';
export const CONFIRM_EMAIL_SUCCESS = 'CONFIRM__EMAIL_SUCCESS';
export const CONFIRM_EMAIL_FAILURE = 'CONFIRM__EMAIL_FAILURE';

export const CLEAR_RESPONSES = 'CLEAR_RESPONSES';

export const ON_BEGIN_PROFILE_FETCH = 'ON_BEGIN_PROFILE_FETCH';
export const ON_PROFILE_FETCH_SUCCESS = 'ON_PROFILE_FETCH_SUCCESS';
export const ON_PROFILE_FETCH_FAILED = 'ON_PROFILE_FETCH_FAILED';

export const GOOGLE_AUTH_FAILURE = 'GOOGLE_AUTH_FAILURE';
export const GOOGLE_AUTH_START = 'GOOGLE_AUTH_START';
export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS';

export const MANAGE_PASSWORD_START = 'MANAGE_PASSWORD_START';
export const MANAGE_PASSWORD_SUCCESS = 'MANAGE_PASSWORD_SUCCESS';
export const MANAGE_PASSWORD_FAILURE = 'MANAGE_PASSWORD_FAILURE';

export const DELETE_USER_ACCOUNT_START = 'DELETE_USER_ACCOUNT_START';
export const DELETE_USER_ACCOUNT_SUCCESS = 'DELETE_USER_ACCOUNT_SUCCESS';
export const DELETE_USER_ACCOUNT_FAILURE = 'DELETE_USER_ACCOUNT_FAILURE';

export const SUBMIT_FEEDBACK_START = 'SUBMIT_FEEDBACK_START';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_FAILURE = 'SUBMIT_FEEDBACK_FAILURE';

export const UPLOAD_PROFILE_IMAGE_START = 'UPLOAD_PROFILE_IMAGE_START';
export const UPLOAD_PROFILE_IMAGE_SUCCESS = 'UPLOAD_PROFILE_IMAGE_SUCCESS';
export const UPLOAD_PROFILE_IMAGE_FAILURE = 'UPLOAD_PROFILE_IMAGE_FAILURE';

export const UPDATE_USER_PROFILE_START = 'UPDATE_USER_PROFILE_START';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';

export const FETCH_RANKS_START = 'FETCH_RANKS_START';
export const FETCH_RANKS_SUCCESS = 'FETCH_RANKS_SUCCESS';
export const FETCH_RANKS_FAILURE = 'FETCH_RANKS_FAILURE';
